import {ReactNode} from "react";
import { ProfileDrawerWrapper } from "widgets/profile/ui/styles.ts";
import {Drawer} from "shared/ui/drawer";

type PasswordEditorDrawerProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

export const PasswordEditorDrawer = (
  {children, isOpen, onClose}: PasswordEditorDrawerProps
) => (
  <Drawer
    isOpen={isOpen}
    onClose={onClose}
    position="right"
  >
    <ProfileDrawerWrapper>
      {children}
    </ProfileDrawerWrapper>
  </Drawer>
)